import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Who has already been shown the first-visit welcome ("Welcome to Rooms").
 *
 * Home with no rooms shows that welcome once; after that, the same empty home
 * is the dashboard's "No Rooms Yet". Per user, so a second account on the
 * same browser still gets its own welcome. Client state, persisted like the
 * session token — a new device sees the welcome once more, which is harmless.
 */
interface HomeState {
  welcomed: string[];
  markWelcomed: (uid: string) => void;
}

const initial = { welcomed: [] as string[] };

export const useHomeStore = create<HomeState>()(
  persist(
    (set) => ({
      ...initial,
      markWelcomed: (uid) => {
        set((state) =>
          state.welcomed.includes(uid)
            ? state
            : { welcomed: [...state.welcomed, uid] },
        );
      },
    }),
    { name: 'floto.home' },
  ),
);

/** The store is a module singleton, so tests must reset it between cases. */
export function resetHomeStore(): void {
  useHomeStore.setState(initial);
}
